export const DDOS_STATUS_CODE = 429
